import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import SvgImage from "../../Icons/Icons";
import { useNavigate } from "react-router-dom";
import Papa from "papaparse";
import TripStatusData from "../../TripAnalysis/SubComponents/TripDataView";
import { getBulkUploadList } from "../../../services/Store/Actions/TripsAction";
import DataTable from "react-data-table-component";
import ShowExcelV3 from "../../Modals/showExcelV3";
import { ref } from "yup";
import { getSignedUrlApiAction } from "../../../services/Store/Actions/appActions";

function BulkUpload(props) {
  const { toggle, modal, setModal, navigatedFrom, type, mode, name } = props;
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState([]);

  const [fileSave, setFileSave] = useState(null);
  const [bulkTransfer, setBulkTransfer] = useState(0);

  const { bulkList } = useSelector((state) => state?.trip);
  console.log("kwmernipni34p", bulkList);
  const handleFileChange = (e) => {
    const file = e?.target.files[0];
    const reader = new FileReader();
    reader.onload = function (event) {
      Papa.parse(event.target.result, {
        header: true,
        complete: (results) => {
          setData(results.data);
        },
      });
    };
    reader.readAsText(file);
  };
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getBulkUploadList({
        type: type,
      })
    );
  }, [refresh]);

  console.log("data......", data);

  const navigate = useNavigate();

  const handleClose = () => {
    setModal(!modal);
  };

  const openFile = (e) => {
    if (e) {
      dispatch(
        getSignedUrlApiAction({ key: e }, (res) => {
          // setDownloadLoader2(false);
          // setLoaderInvoiceId("");
          if (res.status == 200) {
            console.log("kerojkogjr", res?.data);
            window.open(res?.data?.data);
          }
        })
      );
    }
  };

  let columns;
  {
    bulkList?.rows?.map((i, k) => {
      columns = [
        {
          name: "S.No",
          selector: (i, k) => <>{parseFloat(k + 1)}</>,
          width: "9%", // added line here
        },
        {
          name: "File Name",
          width: "20%", // added line here
          selector: (i) => (
            <div
              onClick={() => {
                openFile(i?.inputSheet);
              }}
              style={{
                cursor: "pointer",
                textDecorationLine: "underline",
                color: "blue",
              }}
            >
              {i?.inputSheet}
            </div>
          ),
          wrap: true, // This will wrap the text within the cell
          style: {
            whiteSpace: "pre-wrap", // Ensure the text wraps correctly
            wordBreak: "break-word", // Break long words to fit within the cell
          },
        },
        {
          name: "Upload Date",
          selector: (i) => <div>{i?.createdAt}</div>,
          wrap: true, // This will wrap the text within the cell
          style: {
            whiteSpace: "pre-wrap", // Ensure the text wraps correctly
            wordBreak: "break-word", // Break long words to fit within the cell
          },
        },
        {
          name: "Total Records",
          selector: (i) => <div>{i?.recordsNo}</div>,
          wrap: true, // This will wrap the text within the cell
          style: {
            whiteSpace: "pre-wrap", // Ensure the text wraps correctly
            wordBreak: "break-word", // Break long words to fit within the cell
          },
        },
        {
          name: "Errors in Upload",
          selector: (i) => <div>{i?.ErrorNo}</div>,
        },
        {
          name: "Response file",
          selector: (i) => (
            <div
              onClick={() => {
                openFile(i?.outputSheet);
              }}
              style={{
                cursor: "pointer",
                textDecorationLine: "underline",
                color: "blue",
              }}
            >
              {i?.outputSheet}
            </div>
          ),
          wrap: true, // This will wrap the text within the cell
          style: {
            whiteSpace: "pre-wrap", // Ensure the text wraps correctly
            wordBreak: "break-word", // Break long words to fit within the cell
          },
        },
      ];
    });
  }
  // filesave has csv file exctract the data from it and show it in the table

  return (
    <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width model-Radius"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
      >
        <ModalBody
          className="transactionModalBody"
          //   style={{ marginTop: "25px" }}
        >
          <div className="closeBtnWithBackground" onClick={handleClose}>
            <SvgImage
              classname="close-btn-text"
              style={{ width: "10%", height: "10%" }}
              name="crossBtnWIthBackground"
              width="20%"
              height="20%"
            />
          </div>
          <div
            style={{
              marginTop: " 30px",
              display: "flex",
              justifyContent: "space-between",
            }}
            //   className="PGCollectionBox"
          >
            <div className="PGCollectiontText" style={{ marginLeft: "50px" }}>
              {name}
            </div>
            <div
              className="d-flex"
              onClick={() => {
                props?.sampleFunc();
              }}
            >
              <div style={{ margin: "0 10px 0 0" }}>
                <SvgImage name="Download" width="20px" height="20px" />
              </div>
              <div>Download Template</div>
            </div>
          </div>

          <div
            style={{
              height: "400px",
              minHeight: "400px",
              overflowY: "scroll",
            }}
          >
            <div style={{ margin: "30px 50px 50px 50px" }}>
              <DataTable
                columns={columns}
                data={bulkList?.rows}
                customStyles={{
                  headRow: {
                    style: {
                      backgroundColor: "#ededf1",
                      fontWeight: "bold",
                    },
                  },
                  headCells: {
                    style: {
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      // border: "1px solid rgba(108, 108, 108, 0.2)",
                    },
                  },
                  cells: {
                    style: {
                      fontSize: "14px",
                      // minHeight: "50px",
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                    },
                  },
                  rows: {
                    style: {
                      minHeight: "72px", // optional, for better alignment
                    },
                  },
                }}
                // fixedHeader
                // fixedHeaderScrollHeight='450px'
                // selectableRows
                selectableRowsHighlight
                highlightOnHover
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <label for="file-upload2" class="custom-file-upload3">
              <input
                id="file-upload2"
                type="file"
                onChange={async (e) => {
                  const img = e?.target.files[0];
                  setFileSave(img);
                  console.log("image...", e?.target.files[0]);
                  setBulkTransfer(1);
                }}
              />
              <div
                className="greenButtonNew btn-secondary"
                style={{ width: "160px", padding: "5px" }}
              >
                Upload File
              </div>
            </label>
          </div>
        </ModalBody>
      </Modal>

      {bulkTransfer ? (
        <ShowExcelV3
          toggle={() => setBulkTransfer(!bulkTransfer)}
          modal={bulkTransfer}
          setModal={setBulkTransfer}
          type="fuelVendor"
          fileSave={fileSave}
          setFileSave={setFileSave}
          func={props?.func}
          setRefresh={setRefresh}
          refresh={refresh}
        />
      ) : (
        <></>
      )}
    </div>
  );
}

export default BulkUpload;
